import React, { useState, useEffect } from 'react';
import { getSessions } from '../utils/api';
import '../styles/Home.css';

function Home() {
  const [stats, setStats] = useState({
    totalSessions: 0,
    activeSessions: 0,
    upcomingSessions: 0,
    completedSessions: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const sessions = await getSessions();
      const now = new Date();
      
      const active = sessions.filter(s => {
        const start = new Date(s.startDate);
        const end = new Date(s.endDate);
        return start <= now && end >= now;
      }).length;

      const upcoming = sessions.filter(s => {
        const start = new Date(s.startDate);
        return start > now;
      }).length;

      const completed = sessions.filter(s => {
        const end = new Date(s.endDate);
        return end < now;
      }).length;

      setStats({
        totalSessions: sessions.length,
        activeSessions: active,
        upcomingSessions: upcoming,
        completedSessions: completed
      });
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="home-loading">
        <div className="spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="home">
      <div className="home-header">
        <h1>Planning Plongée</h1>
        <p>Gérez vos sessions de plongée en toute simplicité</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card total">
          <div className="stat-icon"><i className="fas fa-chart-bar"></i></div>
          <div className="stat-content">
            <h3>Total Sessions</h3>
            <p className="stat-number">{stats.totalSessions}</p>
          </div>
        </div>

        <div className="stat-card active">
          <div className="stat-icon"><i className="fas fa-water"></i></div>
          <div className="stat-content">
            <h3>En Cours</h3>
            <p className="stat-number">{stats.activeSessions}</p>
          </div>
        </div>

        <div className="stat-card upcoming">
          <div className="stat-icon"><i className="fas fa-calendar-alt"></i></div>
          <div className="stat-content">
            <h3>À Venir</h3>
            <p className="stat-number">{stats.upcomingSessions}</p>
          </div>
        </div>

        <div className="stat-card completed">
          <div className="stat-icon"><i className="fas fa-check-circle"></i></div>
          <div className="stat-content">
            <h3>Terminées</h3>
            <p className="stat-number">{stats.completedSessions}</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h2>Actions Rapides</h2>
        <div className="actions-grid">
          <a href="/sessions" className="action-card">
            <span className="action-icon"><i className="fas fa-plus-circle"></i></span>
            <h3>Nouvelle Session</h3>
            <p>Créer une nouvelle session de plongée</p>
          </a>
          
          <a href="/sessions" className="action-card">
            <span className="action-icon"><i className="fas fa-calendar-alt"></i></span>
            <h3>Voir les Sessions</h3>
            <p>Consulter toutes vos sessions</p>
          </a>
          
          <a href="/settings" className="action-card">
            <span className="action-icon"><i className="fas fa-cog"></i></span>
            <h3>Paramètres</h3>
            <p>Gérer les activités et niveaux</p>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
